import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { Message } from './message.interface';

@Component({
    selector: 'ca-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.scss'],
    standalone: false
})
export class MessageComponent {
    closed = signal(false);

    @Input() public message: Message;

    @Output() public remove = new EventEmitter<Message>();
}
